import React, { Component } from 'react';
import ReactDom from 'react-dom';
import Moment from 'react-moment';
import { Route } from 'react-router-dom';

import Nav from './Nav'
import Search from './Search';
import Home from './Home';
import {ArticlePage} from './Article';

Moment.globalFormat = 'MMM DD, YYYY';


class App extends Component {
	render() {
		const site_title = '';
		const links = [
			{href: '/', title: 'Home'},
		];

		return (
			<div id='Main' className='container main-container'>
				<Nav site_title={site_title} links={links} />
				<Route exact={true} path="/" key="home-page" component={Home} />
				<Route path="/post/:postname" key="post-page" component={ArticlePage} />
				<Route path="/search/:field/:value" key="search-page" component={Search} />
			</div>
		)
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js